/**
 * ![cyan 50](https://mui.com/static/colors-preview/cyan-50-24x24.png) ![cyan 100](https://mui.com/static/colors-preview/cyan-100-24x24.png) ![cyan 200](https://mui.com/static/colors-preview/cyan-200-24x24.png) ![cyan 300](https://mui.com/static/colors-preview/cyan-300-24x24.png) ![cyan 400](https://mui.com/static/colors-preview/cyan-400-24x24.png) ![cyan 500](https://mui.com/static/colors-preview/cyan-500-24x24.png) ![cyan 600](https://mui.com/static/colors-preview/cyan-600-24x24.png) ![cyan 700](https://mui.com/static/colors-preview/cyan-700-24x24.png) ![cyan 800](https://mui.com/static/colors-preview/cyan-800-24x24.png) ![cyan 900](https://mui.com/static/colors-preview/cyan-900-24x24.png) ![cyan A100](https://mui.com/static/colors-preview/cyan-A100-24x24.png) ![cyan A200](https://mui.com/static/colors-preview/cyan-A200-24x24.png) ![cyan A400](https://mui.com/static/colors-preview/cyan-A400-24x24.png) ![cyan A700](https://mui.com/static/colors-preview/cyan-A700-24x24.png)
 */
const cyan = {
  /**
   * Preview: ![cyan 50](https://mui.com/static/colors-preview/cyan-50-24x24.png)
   */
  50: '#e0f7fa',
  /**
   * Preview: ![cyan 100](https://mui.com/static/colors-preview/cyan-100-24x24.png)
   */
  100: '#b2ebf2',
  /**
   * Preview: ![cyan 200](https://mui.com/static/colors-preview/cyan-200-24x24.png)
   */
  200: '#80deea',
  /**
   * Preview: ![cyan 300](https://mui.com/static/colors-preview/cyan-300-24x24.png)
   */
  300: '#4dd0e1',
  /**
   * Preview: ![cyan 400](https://mui.com/static/colors-preview/cyan-400-24x24.png)
   */
  400: '#26c6da',
  /**
   * Preview: ![cyan 500](https://mui.com/static/colors-preview/cyan-500-24x24.png)
   */
  500: '#00bcd4',
  /**
   * Preview: ![cyan 600](https://mui.com/static/colors-preview/cyan-600-24x24.png)
   */
  600: '#00acc1',
  /**
   * Preview: ![cyan 700](https://mui.com/static/colors-preview/cyan-700-24x24.png)
   */
  700: '#0097a7',
  /**
   * Preview: ![cyan 800](https://mui.com/static/colors-preview/cyan-800-24x24.png)
   */
  800: '#00838f',
  /**
   * Preview: ![cyan 900](https://mui.com/static/colors-preview/cyan-900-24x24.png)
   */
  900: '#006064',
  /**
   * Preview: ![cyan A100](https://mui.com/static/colors-preview/cyan-A100-24x24.png)
   */
  A100: '#84ffff',
  /**
   * Preview: ![cyan A200](https://mui.com/static/colors-preview/cyan-A200-24x24.png)
   */
  A200: '#18ffff',
  /**
   * Preview: ![cyan A400](https://mui.com/static/colors-preview/cyan-A400-24x24.png)
   */
  A400: '#00e5ff',
  /**
   * Preview: ![cyan A700](https://mui.com/static/colors-preview/cyan-A700-24x24.png)
   */
  A700: '#00b8d4',
} as const;

export default cyan;
